export enum FeatureFlags {
  ProjectCost = "ProjectCost",
  TaskPackageExport = "TaskPackageExport",
  Wiki = "Wiki",
  Dashboard = "Dashboard",
  Users = "Users",
  TechnicalComponents = "TechnicalComponents",
  EmailReports = "EmailReports",
  Contracts = "Contracts",
  ProjectHub = "ProjectHub",
  AIReview = "AIReview",
  Sandbox = "Sandbox",
  MaStR = "MaStR",
  Property = "Property",
  TemplateManagement = "TemplateManagement",
  AutomaticDocumentCreation = "AutomaticDocumentCreation",
  Notifications = "Notifications",
  TeamsNotifications = "TeamsNotifications",
  Gesellschaften = "Gesellschaften",
}
